module.exports = __webpack_public_path__ + "static/media/зо.cdc9855e.mp3";